<template>
  <div id="banner" 
       class="bg-emerald-900 text-white w-full z-50 fixed top-0 left-0 flex justify-between items-center text-xs p-4 pt-3 font-medium">
    
    <div class="flex justify-start items-center">
      <div class="mr-6 flex items-center mb-2 lg:mb-0 lg:mr-4">       
        <img 
          src="../../images/logo-trustpilot.png" 
          alt="trustpilot"
          class="mr-2"
          :class="showPhone && $i18n.locale === 'fr' ? 'hidden lg:block' : ''"
          style="transform: translateY(-0.5px)"
          height="17"
          width="70"
          loading="lazy"
        >  
        <img 
          src="../../images/trustpilot_stars.png" 
          :alt="$t('shared.reliability.trustpilot_rating')"
          width="70"
          style="transform: translateY(0.5px)"
          loading="lazy"
        >
        <p class="ml-1">
          {{ $t('shared.reliability.trustpilot_rating') }}
        </p>
      </div>
    </div> 


    <div class="hidden lg:flex">
      <div class="mr-4 flex items-center  mb-2 lg:mb-0 lg:mr-8 opacity-80">
        <swIcon 
          name="shield" 
          :unstyled="true"
          size="w-4" 
        />
        <p class="ml-1">
          {{ $t('shared.reliability.certified') }}
        </p>
      </div>
      <div class="mr-4 flex items-center  mb-2 lg:mb-0 lg:mr-8 opacity-80">
        <swIcon 
          name="smile" 
          :unstyled="true"
          size="w-4" 
        />
        <p class="ml-1">
          {{ $t('shared.reliability.dedicated_advisor') }}
        </p>
      </div>
      <div class="mr-4 flex items-center  mb-2 lg:mb-0 lg:mr-8 opacity-80">
        <swIcon 
          name="thumb-up" 
          :unstyled="true"
          size="w-4" 
        />
        <p class="ml-1">
          {{ $t('shared.reliability.client_space') }}
        </p>
      </div>
    </div>

    <div class="flex justify-start items-center" v-if="showPhone && $i18n.locale === 'fr'">
      <p class="mr-4 hidden lg:block">{{ $t('shared.reliability.a_question') }}</p>
      <a href="tel:+32 2 588 08 24" class="bg-blue-300 flex items-center rounded-xl px-4 py-2 font-semibold">      
        <swIcon 
          name="phone" 
          :unstyled="true"
          size="w-4" 
          class="mr-2"
        />+32 2 588 08 24</a>
    </div>

    <div class="mr-6  items-center mb-2 lg:mb-0 lg:mr-8 hidden lg:flex" v-else>  
      <swIcon 
        name="star" 
        :unstyled="true"
        size="w-4" 
      />
      <swIcon 
        name="star" 
        :unstyled="true"
        size="w-4" 
      />
      <swIcon 
        name="star" 
        :unstyled="true"
        size="w-4" 
      />
      <swIcon 
        name="star" 
        :unstyled="true"
        size="w-4" 
      />
      <p class="ml-1">
        Google {{ $t('shared.reliability.google_rating') }}
      </p>
    </div>
</div>
</template>

<script>
import { hideZendeskChat } from '../../utils/zendesk.js';

export default {
  props: {
    showPhone: {
      type: Boolean,
    },
  },
  mounted () {
    hideZendeskChat();
  },
};
</script>

<style scoped>
#banner{
 font-size: 13px !important;
 height: 63.5px !important;
}
</style>
